
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statenet-redirect/[slug]",
      function () {
        return require("private-next-pages/statenet-redirect/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statenet-redirect/[slug]"])
      });
    }
  